import React from 'react';

import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';
import SubHeaderDashboard from './../components/SubHeaders/DashboardSubHeader';
import ProjectsMenu from './../components/ProjectsMenu';
import HomeDashboard from '../../../components/homeDashboard';
import Steps from 'Images/Demand_flow_chart.svg';
import styled from 'styled-components';
import CompanyTable from '../components/CompanyTable/CompanyTable';

const Container = styled.div`
  max-width: 1024px;
`;

class Dashboard extends React.Component {
  state = {
    tabValue: 0,
    hasProjects: true,
  };

  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.switchTab(nextProps.location.pathname);
    }
  }
  render() {
    return (
      // Page with tickets

      <Grid item className="flex-dashboard">
        <SubHeaderDashboard />
        <ProjectsMenu openProjectsSidebar={this.props.openProjectsSidebar} />
        <div className="dash-padding">
          <Container>
            <HomeDashboard />
            <img src={Steps} alt="" />
            <CompanyTable />
          </Container>
        </div>
      </Grid>
    );
  }
}

export default Dashboard;
